import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaPlus, FaSave, FaTrash } from 'react-icons/fa';
import api from '../../services/api';
import { useHistory } from 'react-router-dom';
import { data, dataMysql, extract, pontoVirgula } from '../../util/util';
import Data from '../../components/Data';
import { toast } from 'react-toastify';
import { FinField, FinInput } from '../../components/FinField';
import '../../css/financeiro-parcela-pagar.css';


export default function CadastroEventoDiaQuantidade({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem("empresa");
    const token = localStorage.getItem('token');
    const [dados, setDados] = useState({ eventodiaquantidade: [] });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(!!id);
    const history = useHistory();

    const calculaTotal = () => {
    }//calculaTotal

    const buscar = () => {
        setIsLoading(true);
        if (id) {
            api({
                method: "get",
                action: '/evento/' + id,
                token: token,
            }).then(response => {
                //extrai dados internos para o array principal
                var dadosRecebidos = extract({
                    jsonLaravel: response.data.data,
                    chaves: []
                });
                setDados(dadosRecebidos);
            }).catch(err => {
                // console.log(err)
            }).finally(() => { setIsLoading(false); });
        } else {
            dados.eventodiaquantidade = [];
            setIsLoading(false);
        }
    };

    const salvar = () => {

        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);
        //converte todas as datas para mysql
        if (dados.eventodiaquantidade)
            dados.eventodiaquantidade.forEach((registro, index) => {
                dados.eventodiaquantidade[index].data = dataMysql(dados.eventodiaquantidade[index].data);
            });

        //update
        api({
            method: 'put',
            action: '/eventoDiaQuantidade/' + id,
            token: token,
            data: {
                ...dados,
                ...{ empresa: empresa }
            }
        })
            .then(function (response) {
                toast.success("Dados salvos com sucesso!");
                history.push("/evento");
            })
            .catch(function (error) {
                toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate processando={isLoading}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">PAX Dia</h1></div>
                    <div className="fin-pp__actions">
                        <button type="button" className="fin-pp__btn fin-pp__btn--primary" disabled={isSubmitting} onClick={salvar}>
                            {isSubmitting ? <><span className="spinner-border spinner-border-sm me-2" />Salvando...</> : <><FaSave size={16} /> Salvar</>}
                        </button>
                    </div>
                </div>

                <form onSubmit={e => { salvar(); e.preventDefault(); }}>
                    <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                        <div className="fin-pp__filters">
                            <FinField label="Evento">
                                <FinInput readOnly type="text" value={dados.nome || ''} />
                            </FinField>
                        </div>
                    </div>

                    <div className="fin-pp__card" style={{ overflow: 'hidden', marginBottom: 16 }}>
                        <div className="fin-pp__tblwrap">
                            <table className="fin-pp__tbl" style={{ tableLayout: 'auto', minWidth: 1000 }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: 50 }}></th>
                                        <th style={{ width: 140 }}>Data</th>
                                        <th>Qtd. Convidados</th>
                                        <th>Qtd. Conv. Previstos</th>
                                        <th>Qtd. Pres. Total</th>
                                        <th>Qtd. Conv. Incl. Local</th>
                                        <th>Qtd. No Show</th>
                                        <th>Qtd. Aéreo Nac.</th>
                                        <th>Qtd. Aéreo Int.</th>
                                        <th>Qtd. Aéreo Reembolso</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dados.eventodiaquantidade ? dados.eventodiaquantidade.map((row, rowIndex) => (
                                        <tr key={rowIndex}>
                                            <td style={{ verticalAlign: 'top', paddingTop: 12 }}>
                                                <button
                                                    type="button"
                                                    className="fin-pp__btn fin-pp__btn--danger fin-pp__btn--sm"
                                                    title="Remover"
                                                    onClick={() => {
                                                        dados.eventodiaquantidade.splice(rowIndex, 1);
                                                        setDados({ ...dados });
                                                    }}
                                                >
                                                    <FaTrash size={14} />
                                                </button>
                                            </td>
                                            <td>
                                                <Data
                                                    value={data(row.data)}
                                                    onChange={(date) => {
                                                        dados.eventodiaquantidade[rowIndex].data = date;
                                                        setDados({ ...dados });
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="fin-pp__input"
                                                    style={{ paddingLeft: 14 }}
                                                    placeholder="Qtd. Convidados"
                                                    value={pontoVirgula(dados.eventodiaquantidade[rowIndex].quantidadeConvidados)}
                                                    onChange={(e) => {
                                                        dados.eventodiaquantidade[rowIndex].quantidadeConvidados = e.target.value;
                                                        calculaTotal();
                                                        setDados({ ...dados });
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="fin-pp__input"
                                                    style={{ paddingLeft: 14 }}
                                                    placeholder="Quant. Conv. Previstos"
                                                    value={pontoVirgula(dados.eventodiaquantidade[rowIndex].quantidadeConvidadosConfirmados)}
                                                    onChange={(e) => {
                                                        dados.eventodiaquantidade[rowIndex].quantidadeConvidadosConfirmados = e.target.value;
                                                        calculaTotal();
                                                        setDados({ ...dados });
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="fin-pp__input"
                                                    style={{ paddingLeft: 14 }}
                                                    placeholder="Quant. Pres. Total"
                                                    value={pontoVirgula(dados.eventodiaquantidade[rowIndex].quantidadePresentesTotal)}
                                                    onChange={(e) => {
                                                        dados.eventodiaquantidade[rowIndex].quantidadePresentesTotal = e.target.value;
                                                        calculaTotal();
                                                        setDados({ ...dados });
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="fin-pp__input"
                                                    style={{ paddingLeft: 14 }}
                                                    placeholder="Quant. Conv. Inclu. Local"
                                                    value={pontoVirgula(dados.eventodiaquantidade[rowIndex].quantidadeConvidadosInclusosLocal)}
                                                    onChange={(e) => {
                                                        dados.eventodiaquantidade[rowIndex].quantidadeConvidadosInclusosLocal = e.target.value;
                                                        calculaTotal();
                                                        setDados({ ...dados });
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="fin-pp__input"
                                                    style={{ paddingLeft: 14 }}
                                                    placeholder="Quant. No Show"
                                                    value={pontoVirgula(dados.eventodiaquantidade[rowIndex].quantidadeNoShow)}
                                                    onChange={(e) => {
                                                        dados.eventodiaquantidade[rowIndex].quantidadeNoShow = e.target.value;
                                                        calculaTotal();
                                                        setDados({ ...dados });
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="fin-pp__input"
                                                    style={{ paddingLeft: 14 }}
                                                    placeholder="Quant. Aéreo Nacional"
                                                    value={pontoVirgula(dados.eventodiaquantidade[rowIndex].quantidadeAereoNacional)}
                                                    onChange={(e) => {
                                                        dados.eventodiaquantidade[rowIndex].quantidadeAereoNacional = e.target.value;
                                                        calculaTotal();
                                                        setDados({ ...dados });
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="fin-pp__input"
                                                    style={{ paddingLeft: 14 }}
                                                    placeholder="Quant. Aéreo Internacional"
                                                    value={pontoVirgula(dados.eventodiaquantidade[rowIndex].quantidadeAereoInternacional)}
                                                    onChange={(e) => {
                                                        dados.eventodiaquantidade[rowIndex].quantidadeAereoInternacional = e.target.value;
                                                        calculaTotal();
                                                        setDados({ ...dados });
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="fin-pp__input"
                                                    style={{ paddingLeft: 14 }}
                                                    placeholder="Quant. Aéreo Reembolso"
                                                    value={pontoVirgula(dados.eventodiaquantidade[rowIndex].quantidadeAereoReembolso)}
                                                    onChange={(e) => {
                                                        dados.eventodiaquantidade[rowIndex].quantidadeAereoReembolso = e.target.value;
                                                        calculaTotal();
                                                        setDados({ ...dados });
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    )) : null}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 24 }}>
                        <button
                            type="button"
                            className="fin-pp__btn fin-pp__btn--primary"
                            onClick={() => {
                                dados.eventodiaquantidade.push({});
                                setDados({ ...dados });
                            }}
                        >
                            <FaPlus size={14} /> Adicionar Item
                        </button>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={isSubmitting}>
                            {isSubmitting ? <><span className="spinner-border spinner-border-sm me-2" />Salvando...</> : <><FaSave size={16} /> Salvar</>}
                        </button>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
